import { render, staticRenderFns } from "./WebhookModal.vue?vue&type=template&id=03b122ea&scoped=true"
import script from "./WebhookModal.vue?vue&type=script&lang=js"
export * from "./WebhookModal.vue?vue&type=script&lang=js"
import style0 from "./WebhookModal.vue?vue&type=style&index=0&id=03b122ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b122ea",
  null
  
)

export default component.exports